import dayjs from 'dayjs';

export const handleDate = (date: string | null, onlyNeedDate?: boolean) => {
  if (!date) {
    return '-';
  }

  const newDate = new Date(date);

  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const day = String(newDate.getDate()).padStart(2, '0');
  const hours = String(newDate.getHours()).padStart(2, '0');
  const minutes = String(newDate.getMinutes()).padStart(2, '0');

  if (onlyNeedDate) {
    return `${year}-${month}-${day}`;
  }
  return `${year}-${month}-${day}
   ${hours}:${minutes}`;
};

export const isCheckMode = window.location.origin.includes('metagymdev') ? '72' : '1';

export const convertToStartDate = (dateString: string) => {
  // dayjs를 사용하여 날짜를 변환
  const formattedDate = dayjs(dateString).format('YYYY-MM-DD') + 'T00:00:00Z';

  return formattedDate;
};

export const convertToEndDate = (dateString: string) => {
  const nextDayMidnight = dayjs(dateString).add(1, 'day').format('YYYY-MM-DD') + 'T00:00:00Z';
  return nextDayMidnight;
};

export const getMonthStartAndEndDates = (dateString = dayjs().format('YYYY-MM-DD')) => {
  const date = dayjs(dateString);
  const startOfMonth = date.startOf('month').format('YYYY-MM-DD') + 'T00:00:00Z';
  const endOfMonth = date.endOf('month').add(1, 'day').format('YYYY-MM-DD') + 'T00:00:00Z';

  return { startOfMonth, endOfMonth };
};

export const getTodayStartAndEndDates = () => {
  const today = dayjs().format('YYYY-MM-DD');
  const startDate = today + 'T00:00:00Z';
  const endDate = dayjs().add(1, 'day').format('YYYY-MM-DD') + 'T00:00:00Z';

  return { startDate, endDate };
};

export const formatBirthday = (value: string): string => {
  const onlyNums = value.replace(/\D/g, '').slice(0, 8);

  if (onlyNums.length < 5) {
    return onlyNums;
  }

  if (onlyNums.length < 7) {
    return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4)}`;
  }

  return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 6)}-${onlyNums.slice(6)}`;
};
